import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseBackendUrl } from '../utils/api-utils';
import { fetchAllSuccess } from "../redux/breakSlice";
import { setBuoyLoading, setCurrentConditions } from "../redux/buoySlice";

export const getAllStations = createAsyncThunk('breaks/getAllStations', async (arg, {dispatch}) => {
    try {
        const response = await fetch(`${baseBackendUrl}/buoys/all`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + arg
            },
        })
        
        if (response.ok) {
            const buoys = await response.json();
            dispatch(fetchAllSuccess({allStations: buoys.stations}))
        }
    } catch (error) {
        console.log(error)
    }
})

export const getCurrentConditions = createAsyncThunk('buoys/getConditions', async (arg, {dispatch}) => {
    dispatch(setBuoyLoading())
    let buoyIdArray = arg.buoys.map(buoy => buoy.id);
    try {
        const response = await fetch(`${baseBackendUrl}/buoys/data/${buoyIdArray}/${arg.breakID}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + arg.token
            }
        })
        
        if (response.ok) {
            let conditions = await response.json();
            for (let i = 0; i < conditions.length; i++) {
                let targetBuoy = arg.buoys.find(buoy => buoy.id === conditions[i].buoyID)
                conditions[i].buoyName = targetBuoy.name;
            }
            console.log(conditions)
            dispatch(setCurrentConditions(conditions))
        }
    } catch (error) {
        console.log(error)
    }
})